import { BcpSessionStorage } from '@bcp/js-storage';

export class SessionStorageRepository {
  constructor(private storage: BcpSessionStorage) { }

  save(keyName: string, value: string): void {
    this.storage.setItem(keyName, value);
  }

  find(keyName: string): string | null {
    return this.storage.getItem(keyName);
  }

  clear(): void {
    this.storage.clear();
  }
}